<template>
  <div>
    <toggle-switch
      :options="switcherOptions"
      @change="updateValues()"
      v-model="selectedValue"
      class="switcher-container"
    ></toggle-switch>
  </div>
</template>

<script>
import ToggleSwitch from "vuejs-toggle-switch";
export default {
  name: "Switcher",
  components: {
    ToggleSwitch
  },
  props: {
    value: String,
    elems: Array
  },
  data: () => {
    return {
      selectedValue: null,
      switcherOptions: {}
    };
  },
  mounted() {
    this.selectedValue = this.value;
    this.switcherOptions = {
      layout: {
        color: "#393939",
        backgroundColor: "#f9f9fb",
        selectedColor: "white",
        selectedBackgroundColor: "green",
        borderColor: "black",
        fontWeight: "normal",
        fontFamily: "'Roboto', sans-serif;",
        fontWeightSelected: "normal",
        squareCorners: false,
        noBorder: true
      },
      size: {
        fontSize: 0.9,
        height: 1.8,
        padding: 0.2
      },
      items: {
        delay: 0.4,
        preSelected: this.value,
        disabled: false,
        labels: this.elems
      }
    };
  },
  methods: {
    updateValues() {
      // this.$emit("update:value", this.selectedMap);
      this.$emit("input", this.selectedValue);
    }
  }
};
</script>

<style></style>
